import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import RestaurantContent from '../../mdx/services/Restaurant/restaurant.mdx';
import './Restaurantdetail.css';

const Heading = ({ children, ...props }) => <h2 className="wedding-photography-details__heading" {...props}>{children}</h2>;
const Paragraph = ({ children, ...props }) => <p className="Restaurantdetail__paragraph" {...props}>{children}</p>;

const Restaurantdetail = () => <section className="Restaurantdetail"><div className="Restaurantdetail__container"><div className="Restaurantdetail__content"><MDXProvider components={{ h2: Heading, h3: Heading, p: Paragraph }}><RestaurantContent /></MDXProvider></div></div></section>;

export default Restaurantdetail;
